import React, { useEffect, useRef, useState } from 'react';
import { MerchantPortalMessages } from 'vopay';

import { useBranding } from '@/providers/Branding.provider';
import { useDataFetchIndicator } from '@/hooks';
import useAuthenticateMerchantUser from '@/hooks/useApi/useAuthenticateMerchantUser';
import { useAlertDialog } from '@/providers/AlertDialog.provider';
import { useTranslation } from 'react-i18next';
import { usePartnerLogin } from '@/providers/PartnerLogin.provider';

const OnBoardingFormTrackerPage: React.FC = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [, dataFetchIndicator] = useDataFetchIndicator();
  const { primaryColor } = useBranding();
  const { authenticateMerchantUser } = useAuthenticateMerchantUser();
  const { error } = useAlertDialog();
  const { t } = useTranslation('translations', { keyPrefix: 'OnBoardingFormTrackerPage' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const {
    response: { userRole },
  } = usePartnerLogin();

  const [isLoaded, setIsLoaded] = useState(false);
  const link = `${import.meta.env.VITE_ACCOUNT_ONBOARDING_MERCHANT_BASE_URL}?isEmbedded=true`;
  const [merchantUserToken, setMerchantUserToken] = useState<string | undefined>(undefined);

  const postMessageToIframe = (message: MerchantPortalMessages) => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow?.postMessage(message, '*');
    }
  };

  useEffect(() => {
    const authenticateUser = async () => {
      const response = await authenticateMerchantUser();
      if (!response.Success) {
        dataFetchIndicator(false);
        error(tGlobal('error'), response.ErrorMessage);
        console.error('Error authenticating merchant user:', response.ErrorMessage);
        return;
      }
      setMerchantUserToken(response.MerchantUserToken);
    };

    authenticateUser();
  }, []);
  useEffect(() => {
    const handleMessage = async (event: MessageEvent<MerchantPortalMessages>) => {
      // if (event.origin !== 'http://localhost:4176') return; should do add later
      if (!event.data) return;
      const { type, code } = event.data;
      if (type === 'INFO' && code === 'INIT') {
        postMessageToIframe({
          type: 'ACTION',
          code: 'CONFIG',
          payload: {
            sessionToken: merchantUserToken || '',
            hideHeader: true,
            hideFooter: true,
            primaryColor: primaryColor,
            role: userRole,
          },
        });
      }
      if (type === 'INFO' && code == 'CONFIG_PROCESSED') {
        setIsLoaded(true);
        dataFetchIndicator(false);
      }
    };

    dataFetchIndicator(true);
    window.addEventListener('message', handleMessage);

    return () => {
      dataFetchIndicator(false);
      window.removeEventListener('message', handleMessage);
    };
  }, [merchantUserToken]);

  return (
    <>
      {link && merchantUserToken && (
        <iframe
          ref={iframeRef}
          src={link}
          title={t('pageTitle')}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            visibility: isLoaded ? 'visible' : 'hidden',
            paddingBottom: '60px',
          }}
          allow="clipboard-write"
          seamless
        ></iframe>
      )}
    </>
  );
};

export default OnBoardingFormTrackerPage;
